export default __webpack_public_path__ + "static/media/prodigyLogo.8488c3c6.jpg";